<template>
  <div class="hero-thanks">
    <div class="hero-inner container">
      <div class="hero-text">
        <h1 v-show="showButton">{{ header }}</h1>
        <p class="mb-2rem">
          {{ paragraph }} </p>
        <!-- <div class="button-row" v-show="showButton">
          <button @click="$router.push({ name: 'Request' }).catch(() => {})">
            Continue<i class="fas fa-caret-right"></i>
          </button>
        </div> -->
      </div>
      <div class="sunheroimage">
        <img v-bind:src="imageSource" alt=""/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    header: {
      type: String,
      required: false,
      default: ''
    },
    paragraph: {
      type: String,
      required: false,
      default: ''
    },
    image: {
      type: String,
      required: false,
      default: ''
    },
    sunheroClass: {
      type: String,
      required: false,
      default: ''
    },
    showButton: {
      type: String,
      required: false,
      default: 'false'
    }
  },
  computed: {
    imageSource () {
      return require(`@/assets/images/global/${this.image}.png`)
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.hero-thanks {
  position: relative;
  background-image: url("~@/assets/images/global/burst-left.png");
  background-size: auto 100%;
  background-position: left center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    background-image: none;
  }

  &:before {
    background-image: url("~@/assets/images/global/burst-right.png");
    background-size: auto 100%;
    background-position: right center;
    background-repeat: no-repeat;
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      background-image: none;
    }
  }

  .sunheroimage {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    top: 2%;
    left: 70%;
    width: 65%;

    @media screen and (max-width: ~"@{mq-md-bp}em") {
      top: 61%;
      left: 25%;
      justify-content: center;
    }

    img {
      width: 100%;
      object-fit: contain;
    }
  }

  .hero-inner {
    display: flex;
    flex-flow: row;
    align-content: space-around;
    padding-top: .clampedW(8, @md-bp, @large-bp) [ @result];
    padding-bottom: 0;
    @media screen and (max-width: ~"@{mq-xs-bp}") {
      padding-bottom: 12rem;
    }

    .hero-text {
      margin-top: 10rem;

      .hero-callout {
        color: @color-dk-orange;
        font-weight: 700;
        text-decoration: underline;
      }

      .mb-2rem {
        margin-bottom: 2rem;
      }
    }

    h1 {
      font-size: 60px;
      text-align: left;
      text-transform: uppercase;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        font-size: 45px;
        text-align: center;
      }
    }

    h1,
    div,
    p {
      // flex: 0 1 100%;
    }

    p {
      font-size: .clampedW(3, @md-bp, @large-bp) [ @result];
      max-width: 70%;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        max-width: 100%;
        font-size: .clampedW(4, @md-bp, @large-bp) [ @result];
      }

      &.footnote {
        font-size: .clampedW(2, @md-bp, @large-bp) [ @result];
        line-height: 1.2;
        // padding: 0 25%;
      }
    }
  }
}

.button-row {
  display: flex;

  @media screen and (max-width: ~"@{mq-md-bp}em") {
    justify-content: center;
  }
}

button {
  background-color: @color-orange;
  font-weight: 700;
  font-family: @open-sans-font;
  font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
  text-transform: uppercase;
  border: none;
  margin-top: 20px;
  padding: 1rem 1rem 1rem 1rem;
  cursor: pointer;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 226px;
    font-size: 20px;
  }

  .fa-caret-right {
    margin-left: 7px;
  }
}
</style>
